import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { FC } from "react";
import Icon from "../Icon";
export type StarsRatingProps = {
  stars: number;
  size?: string;
  className?: string;
};
const STAR_COUNT = 5;
const StarsRating: FC<StarsRatingProps> = t0 => {
  const $ = _c(19);
  const {
    stars,
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? "14" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = Array.from({
      length: STAR_COUNT
    });
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== size) {
    t3 = t2.map((_, index) => <Icon key={index} type="Star" size={size} theme="filled" fill="currentColor" />);
    $[1] = size;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const starRow = t3;
  let t4;
  if ($[3] !== className) {
    t4 = clsx("relative inline-flex", className);
    $[3] = className;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = `${stars} / ${STAR_COUNT}`;
  let t6;
  if ($[5] !== starRow) {
    t6 = <span className="flex text-neutral-50">{starRow}</span>;
    $[5] = starRow;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = `${Math.max(0, Math.min(100, stars / STAR_COUNT * 100))}%`;
  let t8;
  if ($[7] !== t7) {
    t8 = {
      width: t7
    };
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== starRow) {
    t9 = <span className="flex w-max shrink-0">{starRow}</span>;
    $[9] = starRow;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t8 || $[12] !== t9) {
    t10 = <span className="absolute inset-none flex overflow-hidden text-marigold-525" style={t8}>{t9}</span>;
    $[11] = t8;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
    t11 = <span className={t4} role="img" aria-label={t5}>{t6}{t10}</span>;
    $[14] = t10;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  return t11;
};
export default StarsRating;